/**
 * Created by jan.zientek on 05.12.2022.
 */

import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import makeStyles from '@mui/styles/makeStyles';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {useTranslation} from "react-i18next";
import {user} from "../../store/reducers/user";

const useStyles = makeStyles((theme) => ({
    menu: {
        width: "min-content",
        height: "inherit"
    },
    userName: {
        padding: "20px 10px 5px 10px",
        textAlign: "center",
        minWidth: "200px"
    },
    userEmail: {
        padding: "0px 10px 20px 10px",
        fontSize: 10,
        textAlign: 'center',
        minWidth: "200px"
    },
    listButton: {
        cursor: "pointer",
        textAlign: 'center'
    },
    icon: {
        cursor: "pointer"
    }

}));

function HoldingPenMenu(props) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    const userObject = useSelector(user);

    const logOut = () => {
        const authObject = window.keycloak ? window.keycloak : window.auth;
        authObject.logout();
    };

    return (
        <div className={classes.menu + " user-menu-grid"}>
            <span>
                <span height={175}>
            { userObject && <div>
                <div className={classes.userName}> { userObject.firstName }  { userObject.familyName } ({ userObject.userName }) </div>
                <div className={classes.userEmail}> { userObject.email } </div>
            </div>}
            </span>
            <List className={classes.root}>
                <ListItem onClick={ logOut } className={classes.listButton} >
                    <ListItemText primary={t("Sign out")}/>
                </ListItem>
            </List>
            </span>
        </div>
    );

}

export default HoldingPenMenu;